var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import transcodeLocale from "./transcode-locale";
export class FetchError extends Error {
    constructor(message, status, statusText, code) {
        super(message);
        this.name = "FetchError";
        this.status = status;
        this.statusText = statusText;
        this.code = code;
    }
}
export const customFetch = (partialURL, _a) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    var { baseURL, params, authToken, locale, method: originalMethod, body: originalBody, headers: originalHeaders } = _a, options = __rest(_a, ["baseURL", "params", "authToken", "locale", "method", "body", "headers"]);
    const headers = new Headers(originalHeaders);
    headers.append("Content-Type", "application/json");
    const body = originalBody ? JSON.stringify(originalBody) : undefined;
    const method = body != null && originalMethod == null ? "POST" : originalMethod;
    if (locale) {
        headers.set("X-Locale", transcodeLocale(locale !== null && locale !== void 0 ? locale : "UNKNOWN", "icu", "iso3166"));
    }
    if (authToken) {
        headers.set("Authorization", authToken);
    }
    const url = new URL(partialURL, baseURL);
    if (params) {
        const urlParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (Array.isArray(value)) {
                for (const item of value) {
                    urlParams.append(key, String(item));
                }
            }
            else {
                urlParams.append(key, String(value));
            }
        }
        url.search = urlParams.toString();
    }
    const response = yield fetch(url, Object.assign(Object.assign({}, options), { method,
        body,
        headers }));
    if (!response.ok) {
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        let errorCode;
        try {
            // Try to parse response as JSON
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                const errorData = (yield response.json());
                // Extract message from common error response formats
                errorMessage = (_b = errorData.message) !== null && _b !== void 0 ? _b : errorMessage;
                errorCode = errorData.code;
            }
            else {
                // If not JSON, try to get text
                const textData = yield response.text();
                if (textData) {
                    errorMessage = textData;
                }
            }
        }
        catch (_c) {
            // If parsing fails, keep the default error message
        }
        throw new FetchError(errorMessage, response.status, response.statusText, errorCode);
    }
    if (response.status === 204) {
        return null;
    }
    const result = (yield response.json());
    return result;
});
//# sourceMappingURL=custom-fetch.js.map